/* eslint-disable no-param-reassign */
/* eslint no-underscore-dangle: 0 */

import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  errorNotification: {},
  headerTitle: '',
  successNotification: {
    status: false,
    message: '',
  },
};

export const notificationSlice = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    setErrorNotification: (state, action) => {
      state.errorNotification = action.payload;
    },
    setHeaderTitle: (state, action) => {
      state.headerTitle = action.payload;
    },
    setSuccessNotification: (state, action) => {
      state.successNotification = action.payload;
    },
    resetNotification: (state) => {
      Object.assign(state, initialState);
    },
  },
});

export const {
  setErrorNotification,
  setSuccessNotification,
  setHeaderTitle,
  resetNotification,
} = notificationSlice.actions;

export default notificationSlice.reducer;
